[
  {
    "value": "ACT",
    "min": 1,
    "max": 36.0
  },
  {
    "value": "GMAT",
    "min": 200,
    "max": 900
  },
  {
    "value": "GRE",
    "min": 260,
    "max": 340
  },
  {
    "value": "SAT",
    "min": 400,
    "max": 1600
  }
]
